import { TRootState }    from 'Redux/Reducers';

export const isOtpFailed = (state: TRootState): boolean => state.insuranceCooperation.wrongOtp;
